import axios from 'axios';
import { defaultLocale } from './translation';
import { setErrorDispatcher } from '../hooks/setErrorDispatcher';
import LocalStorage, { LOCAL_STORAGE_KEYS } from './localStorage';

// Create new instance for base url and related request parametres
const instance = axios.create({});

instance.interceptors.request.use(config => {
    const token = sessionStorage.getItem('token');
    const macAddress = sessionStorage.getItem('macAddress');
    const lang = LocalStorage.getItem(LOCAL_STORAGE_KEYS.lang) || defaultLocale;
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    config.headers['x-lang'] = lang;
    config.headers['x-mac-address'] = macAddress;
    return config;
});

instance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (!error.status) {
            console.log({ error });
            // window.location = '/500';
            // return;
        }
        if (401 === error?.response?.status) {
            const errDesc = error?.response?.data?.info?.errors[0]?.description;
            if (
                errDesc === 'UNAUTHORIZED' ||
                error?.request?.responseURL?.includes('security/auth/logout')
            ) {
                window.location = '/';
                sessionStorage.clear();
                return LocalStorage.clear();
            }
            if (window.location.pathname !== '/user/login') {
                setErrorDispatcher(true);
            }
        }
        return Promise.reject(error);
    }
);
// Alter defaults after instance has been created
// instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
instance.defaults.headers.common['Accept'] = 'application/json';
instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.get['Content-Type'] = 'application/json';

export default instance;
